export function applyRule(value: string, rule: RegExp, evalLenghtDiff: boolean): number {
  const newValue = value.replace(rule, '');
  const ruleLenght = newValue.length;
  let retValue = 0;
  if (evalLenghtDiff) {
    if ((value.length - ruleLenght) >= 1) {
      retValue = 1;
    }
  } else if (ruleLenght >= 1) {
    retValue = 1;
  }
  return retValue;
}
